import { render, staticRenderFns } from "./pwriteoff.vue?vue&type=template&id=f2bd9a88&scoped=true&"
import script from "./pwriteoff.vue?vue&type=script&lang=js&"
export * from "./pwriteoff.vue?vue&type=script&lang=js&"
import style0 from "./pwriteoff.vue?vue&type=style&index=0&id=f2bd9a88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bd9a88",
  null
  
)

export default component.exports